/* PagingSiteFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

class PagingSitesFeed extends PagingFeed {
    _getFeed() {
        //_id: {$nin: [this.activeOrgId]}
        // if (this._filter) {
        //     if (!this._filter.$systemQuery) {
        //         this._filter.$systemQuery = {
        //             id: {$ne: this._activeOrgId},
        //         };
        //     } else {
        //         const sysQuery = JSON.parse(JSON.stringify(this._filter.$systemQuery));
        //         this._filter.$systemQuery = {
        //             $and: [sysQuery, {id: {$ne: this._activeOrgId}}],
        //         };
        //     }
        // }
        return this._EntityDef.startSitesFeed(
            this._activeOrgId,
            this._filter,
            this._entityFields,
            this._sort,
            {
                skip: 0,
                limit: this._pageSize * 2,
            }
        );
    }

    _getDistinctValuesOfField(tenantId, field) {
        return this._EntityDef.startSiteDistinctValuesFeed(tenantId, field);
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadSiteIdsForSelection(tenantId, selection);
    }

    getSiteEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getSiteEntitiesNameById(ids) {
        return this.getEntitiesValueByIdAsProm(ids, "name");
    }

    getSiteEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingSitesFeed;
